import React, { useState } from 'react';
import Select from 'react-select';
import Flag from 'react-world-flags';

// Country data with flag code, country name, and country code
const countries = [
  // Global countries
  { code: 'US', label: 'United States', countryCode: '+1' },
  { code: 'CA', label: 'Canada', countryCode: '+1' },
  { code: 'GB', label: 'United Kingdom', countryCode: '+44' },
  { code: 'DE', label: 'Germany', countryCode: '+49' },
  { code: 'FR', label: 'France', countryCode: '+33' },
  { code: 'IN', label: 'India', countryCode: '+91' },
  { code: 'AU', label: 'Australia', countryCode: '+61' },
  { code: 'IT', label: 'Italy', countryCode: '+39' },
  { code: 'ES', label: 'Spain', countryCode: '+34' },
  { code: 'BR', label: 'Brazil', countryCode: '+55' },
  { code: 'MX', label: 'Mexico', countryCode: '+52' },
  { code: 'CN', label: 'China', countryCode: '+86' },
  { code: 'JP', label: 'Japan', countryCode: '+81' },
  { code: 'RU', label: 'Russia', countryCode: '+7' },
  { code: 'ZA', label: 'South Africa', countryCode: '+27' },
  { code: 'KR', label: 'South Korea', countryCode: '+82' },
  { code: 'PH', label: 'Philippines', countryCode: '+63' },

  // Arabian Countries (Middle East & North Africa)
  { code: 'SA', label: 'Saudi Arabia', countryCode: '+966' },
  { code: 'AE', label: 'United Arab Emirates', countryCode: '+971' },
  { code: 'EG', label: 'Egypt', countryCode: '+20' },
  { code: 'KW', label: 'Kuwait', countryCode: '+965' },
  { code: 'QA', label: 'Qatar', countryCode: '+974' },
  { code: 'BH', label: 'Bahrain', countryCode: '+973' },
  { code: 'OM', label: 'Oman', countryCode: '+968' },
  { code: 'JO', label: 'Jordan', countryCode: '+962' },
  { code: 'LB', label: 'Lebanon', countryCode: '+961' },
  { code: 'SY', label: 'Syria', countryCode: '+963' },
  { code: 'IQ', label: 'Iraq', countryCode: '+964' },
  { code: 'YE', label: 'Yemen', countryCode: '+967' },
  { code: 'PS', label: 'Palestine', countryCode: '+970' },
  { code: 'SD', label: 'Sudan', countryCode: '+249' },
  { code: 'MA', label: 'Morocco', countryCode: '+212' },
  { code: 'TN', label: 'Tunisia', countryCode: '+216' },
  { code: 'DZ', label: 'Algeria', countryCode: '+213' },
  { code: 'LY', label: 'Libya', countryCode: '+218' },
  { code: 'MR', label: 'Mauritania', countryCode: '+222' },

  // Some additional global countries
  { code: 'SE', label: 'Sweden', countryCode: '+46' },
  { code: 'FI', label: 'Finland', countryCode: '+358' },
  { code: 'NO', label: 'Norway', countryCode: '+47' },
  { code: 'DK', label: 'Denmark', countryCode: '+45' },
  { code: 'PL', label: 'Poland', countryCode: '+48' },
  { code: 'TR', label: 'Turkey', countryCode: '+90' },
  { code: 'GR', label: 'Greece', countryCode: '+30' },
  { code: 'PT', label: 'Portugal', countryCode: '+351' },
  { code: 'HR', label: 'Croatia', countryCode: '+385' },
  { code: 'UA', label: 'Ukraine', countryCode: '+380' },
  { code: 'RO', label: 'Romania', countryCode: '+40' },
  { code: 'BG', label: 'Bulgaria', countryCode: '+359' },
  { code: 'HR', label: 'Croatia', countryCode: '+385' },
  { code: 'IS', label: 'Iceland', countryCode: '+354' },

  // You can continue adding other countries as needed...
];

const customOption = (props) => {
  const { data, innerRef, innerProps } = props;
  return (
    <div ref={innerRef} {...innerProps} style={{ display: 'flex', alignItems: 'center', padding: '8px' }}>
      <Flag code={data.code} style={{ width: 20, height: 15, marginRight: 10 }} />
      {data.label}
    </div>
  );
};

// Custom component to show code in the selected value
const customSingleValue = ({ data }) => (
  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
    <Flag code={data.code} style={{ width: 18, height: 15 }} />
    <span style={{ marginLeft: '5px' }}>{data.countryCode}</span>
  </div>
);

const CountrySelect = ({ value, onChange }) => {
  
  return (
    <Select
      options={countries}
      value={value}  // Pass value as a prop from parent
      onChange={onChange}  // Handle change from parent component
      getOptionLabel={(e) => (
        <div style={{ display: 'flex', alignItems: 'center' }}>
          <Flag code={e.code} style={{ width: 20, height: 15, marginRight: 10 }} />
          {e.label}
        </div>
      )}
      components={{ SingleValue: customSingleValue, Option: customOption }}
      placeholder="Select a country"
      isSearchable={true} // Enable the search functionality
      styles={{
        control: (base) => ({
          ...base,
          backgroundColor: '#B49345', // Set background color
          border: 'none', // Remove the border
          boxShadow: 'none', // Remove box shadow
          cursor: 'pointer', // Show pointer cursor on hover
        }),
        singleValue: (base) => ({
          ...base,
          color: 'white', // Make the selected value white
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }),
        dropdownIndicator: (base) => ({
          ...base,
          color: 'white', // White dropdown arrow
        }),
        indicatorSeparator: () => ({
          display: 'none', // Remove the indicator separator
        }),
        menu: (base) => ({
          ...base,
          cursor:"pointer",
          borderRadius:"8px 0 0 8px",
          width:"135px", 
        }),
        option: (base) => ({
          ...base,
          color: 'black', // Set the text color in the dropdown
          cursor:"pointer",
        }),
        placeholder: (base) => ({
          ...base,
          color: 'white', // Placeholder color
        }),
      }}
    />
  );
};

export default CountrySelect;